function getCSRFToken(): string {
  if (typeof document === 'undefined') return ''
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
}

function submitForm(action: string, method: string = 'POST') {
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = action

  if (method !== 'POST') {
    const methodInput = document.createElement('input')
    methodInput.type = 'hidden'
    methodInput.name = '_method'
    methodInput.value = method
    form.appendChild(methodInput)
  }

  const csrf = document.createElement('input')
  csrf.type = 'hidden'
  csrf.name = 'authenticity_token'
  csrf.value = getCSRFToken()
  form.appendChild(csrf)

  document.body.appendChild(form)
  form.submit()
}

export function useAuth() {
  const signOut = () => submitForm('/users/sign_out', 'delete')

  return { signOut }
}
